import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DonutModel, PieChartModel } from '../../services/stats.model';
import { StatsService } from '../../services/stats.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss']
})
export class DonutChartComponent implements OnInit {  
  chartData: PieChartModel[] = [];
  data: DonutModel;
  colorScheme:any = {
    domain: []
  };
  view: any[] = [200, 200];
  doughnut = true;

  machines = 0;
  @Input() equipmentColorMap: any[] ;
  @Input() productMixData: any;
  customLoaderIsLoading = false;//customLoaderIsLoading for customSpinner.
  customLoaderErrorMsg:string;
  customLoaderRedirectButtonLabel:string;
  customLoaderRedirectButtonUrl:string;
  constructor(
  ) {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.productMixData && changes.productMixData.currentValue && changes.productMixData.currentValue !== changes.productMixData.previousValue){
      this.customLoaderIsLoading = true;
      this.chartData = [];
      this.data = changes.productMixData.currentValue;
      this.colorScheme.domain = [];
      this.machines = 0;
      this.data.productMix.forEach(item => {
        this.machines += Number(item.noOfEquips);
        let color = this.equipmentColorMap.find(x=> x.id === Number(item.activityId));
        this.colorScheme.domain.push(color ? this.equipmentColorMap.find(x=> x.id === Number(item.activityId)).colour : "#FFFFFF");
        let tmp: PieChartModel = {
          name: item.activityId,
          value: Number(item.percentage)
        }
        this.chartData.push(tmp);
      });
      this.customLoaderIsLoading = false;
    }
  }

  goToHeatmap() {
    localStorage.setItem('showHeatMapSection', 'true');
		window.location.href="halo.html#/dashboard";
  }
}
